import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { images, routes, whyPoints } from '../data/site';
import { ReviewsCallout } from './ReviewsCallout';
import { SiteLink } from './SiteLink';
export function WhyPegasus() {
  return <section aria-labelledby="why-heading" className="w-full border-y border-ink/10 bg-white" data-id="element-558" data-mp="1sj6gw5nxbo3m">
      <div className="mx-auto max-w-container px-5 py-12 sm:px-8 lg:py-16" data-id="element-559" data-mp="1nqddbl46ylt4">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-12 lg:gap-12" data-id="element-560" data-mp="21ia2pheh6hlt">
          <div className="lg:col-span-6" data-id="element-561" data-mp="1wjysv6o6k73l">
            <p className="text-[14px] font-bold uppercase text-pine" data-id="element-562" data-mp="1wix98dt3mca9">Why Pegasus</p>
            <h2 id="why-heading" className="mt-2 text-h2-mobile font-semibold text-ink lg:text-h2-desktop" data-id="element-563" data-mp="2bfxymanthv5k">
              Local Experience That Stays With You
            </h2>
            <p className="mt-4 text-body text-ink/80 sm:text-body-lg" data-id="element-564" data-mp="h3hwnm22136i">
              We&rsquo;ve been part of Brooklyn and Michigan's Irish Hills since 1977. We know
              these products, we know Michigan backyards, and we believe the relationship should
              continue long after the sale.
            </p>
            <p className="mt-3 text-body text-ink/80 sm:text-body-lg" data-id="element-565" data-mp="3uguq85ejfbd0">
              Our team helps customers compare options, plan for ownership and find support when
              questions or service needs come up. That practical, local guidance is the difference.
            </p>

            <ul className="mt-6 grid grid-cols-1 gap-x-8 gap-y-2 sm:grid-cols-2" data-id="element-566" data-mp="d261k8xlqfq0">
              {whyPoints.map(point => <li key={point} className="flex items-start gap-2" data-id="element-567" data-mp="i3d7e2g6p4u1">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-pine" aria-hidden="true" data-id="element-568" data-mp="m3niftiu2lfr" />
                  <span className="text-[16px] leading-6 text-ink" data-id="element-569" data-mp="r1oys6ovk6nj">{point}</span>
                </li>)}
            </ul>

            <div className="mt-7 flex flex-wrap items-center gap-4" data-id="element-570" data-mp="2nwv19cxnnl6e">
              <SiteLink to={routes.about} className="inline-flex min-h-[48px] items-center rounded-btn bg-pegasus-magenta px-6 text-[16px] font-bold text-white transition-colors duration-150 ease-out hover:bg-[#bb2f83]" data-id="element-571" data-mp="2sttxc10vq278">
                Why Choose Pegasus
              </SiteLink>
              <SiteLink to={routes.location} className="inline-flex min-h-[44px] items-center gap-1.5 text-[16px] font-medium text-pegasus-blue underline decoration-pegasus-blue/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-pegasus-magenta hover:decoration-pegasus-magenta" data-id="element-572" data-mp="8xf7tbcgybwr">
                Visit the Showroom
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-573" data-mp="rsdlm8t4wcue" />
              </SiteLink>
            </div>
          </div>

          <div className="lg:col-span-6" data-id="element-574" data-mp="11o76qgkx5ens">
            <div className="aspect-[4/3] w-full overflow-hidden rounded-card" data-id="element-575" data-mp="11oytd1wjg21x">
              <img src={images.whyPegasus} alt="Pegasus Spas storefront and roadside sign in Brooklyn, Michigan." className="h-full w-full object-cover object-center" loading="lazy" decoding="async" data-id="element-576" data-mp="wqf68y67kk7z" />
            </div>
          </div>
        </div>

        <ReviewsCallout data-id="element-577" data-mp="16f2madz4gw2d" />
      </div>
    </section>;
}